import Region from "../../../../../models/Region";
import CNV_TYPES from "../../../constants/supportedCnv";

class CnvCall {
  constructor(data, chr, keyIndex) {
    const start = data[keyIndex.start];
    const end = data[keyIndex.end];

    this.id = data[keyIndex.id];
    this.type = data[keyIndex.type];
    this.bf = data[keyIndex.BF];
    this.exonSpan = data[keyIndex.nexons];
    this.exonStart = data[keyIndex.start_p];
    this.exonEnd = data[keyIndex.end_p];
    this.readsExpected = data[keyIndex.reads_expected];
    this.readsObserved = data[keyIndex.reads_observed];
    this.readsRatio = data[keyIndex.reads_ratio];
    this.copyNumber = data[keyIndex.CN];
    this.region = new Region(start, end, chr);
  }

  get spec() {
    const type = CNV_TYPES[this.type];
    const { chromosome, x0, size } = this.region;
    if (!type) return `${chromosome.name}:${x0}:L${size}`;
    return `${chromosome.name}:${x0}:L${size}:${type}`;
  }

  get link() {
    const type = CNV_TYPES[this.type];
    if (!type) return null;
    const { chromosome, x0, size } = this.region;
    return `/cnv/${chromosome.genomeId}/${chromosome.name}:${x0}:L${size}:${type}`;
  }
}

export default CnvCall;
